const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;
const CloseIcon = require('@material-ui/icons/Close').default;
const delay = require('mn-utils/delay');
const {
  backLocationDebounced,
} = require('../../../router');
const withState = require('../../../utils/withState');
const {
  approve$,
} = require('../../../emitters/popup');
const ButtonH = require('../../dumb/Button/H');
const ButtonI = require('../../dumb/Button/I');
const TextFieldReg = require('../../dumb/TextField/Reg');


const PopupInner = withState((setState) => {
  function handleChangeMessage(e) {
    setState({
      message: e.target.value,
    });
  }
  return (state, props) => {
    const options = props.options || {};
    const title = options.title || '';
    const text = options.text || '';
    const message = state.message || '';
    return (
      <>
        {title ? (<div className="mb35 tc f24 lh">{title}</div>) : null}
        {text ? (<div
          className="mb15 tc"
          dangerouslySetInnerHTML={{__html: text}}
        />) : null}
        <div className="mb15">
          <TextFieldReg
            placeholder="Message"
            className="w"
            multiline
            rows={6}
            value={message}
            onChange={handleChangeMessage}
            inputProps={{
              maxLength: 1024,
            }}
          />
        </div>
        <div className="mt35 layoutRow fhaC fvaC mhA">
          <div className="cfx mh-8 (lt|ph8)>1">
            <div>
              <ButtonH
                onClick={backLocationDebounced}
              >{options.textCancel || 'Cancel'}</ButtonH>
            </div>
            <div>
              <ButtonI
                onClick={() => {
                  backLocationDebounced();
                  delay(options.callback, 50, [message]);
                }}
              >{options.textConfirm || 'Yes'}</ButtonI>
            </div>
          </div>
        </div>
      </>
    );
  };
}, {});


module.exports = withState((setState) => {
  return (state, props) => {
    const {
      open,
      animate,
    } = state;
    const options = open || animate || state.lazyOpen;

    return options ? (
      <div
        className={'fixed s z10 cF bg08 o0 dn ovxH ovyA o100.active'
          + (open && animate ? ' active' : '')}
      >
        <div className="layoutRow fhaC fvaC w hmin rlv p10 p5@m5">
          <ButtonBase
            className="dB*2 abs*2 s"
            component="div"
            onClick={backLocationDebounced}
          />
          <div className="bg0 w wmax640 hmin100 rlv p40 ov r5 ph15@m5">
            <PopupInner
              options={options}
            />
            <div className="abs srt10 r ov">
              <ButtonBase
                className="layoutRow fhaC fvaC sq40 dn c0 c4<1:h"
                component="div"
                onClick={backLocationDebounced}
                centerRipple
              >
                <CloseIcon className="sq30*2"/>
              </ButtonBase>
            </div>
          </div>
        </div>
      </div>
    ) : null;
  };
}, {
  open: approve$,
  animate: approve$.delay(50),
  lazyOpen: approve$.delay(500),
});
